import * as types from "../actions/actionTypes";

const initialState = {
    loginHistory: [],
    loginAggregation: [],
    uniqueLoginAggregation: [],
    totalPageView: [],
    pageView: [],
    transactionsCreated: [],
    preTransactionsCreated: [],
};

export default function adminReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_LOGINHISTORY: {
      const { data } = action.payload;
      return {
        ...state,
        loginHistory: data,
      };
    }

    case types.GET_LOGINAGGREGATION: {
      const { data } = action.payload;
      return {
        ...state,
        loginAggregation: data,
      };
    }

    case types.GET_UNIQUELOGINAGGREGATION: {
      const { data } = action.payload;
      return {
        ...state,
        uniqueLoginAggregation: data,
      };
    }

    case types.GET_TOTALPAGEVIEWPERCLIENT: {
      const { data } = action.payload;
      return {
        ...state,
        totalPageView: data,
      };
    }

    case types.GET_PAGEVIEWPERCLIENT: {
      const { data } = action.payload;
      return {
        ...state,
        pageView: data,
      };
    }

    case types.GET_TRANSACTIONSCREATED: {
      const { data } = action.payload;
      return {
        ...state,
        transactionsCreated: data,
      };
    }

    case types.GET_PRETRANSACTIONSCREATED: {
      const { data } = action.payload;
      return {
        ...state,
        preTransactionsCreated: data,
      };
    }

    default:
      return state;
  }
}
